var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ClaimForm',_vm._b({},'ClaimForm',_vm.funnelData,false))
}
var staticRenderFns = []

export { render, staticRenderFns }